<tt-page>
    <ng-container *ngIf="tabletSize.matches; else mobileView">
        <tt-card *ngIf="itemState === 'p2releasenoteedit'" class="col-xs-12 col-md-6 p-5">
            <tt-page-heading ttModel="h_release_notes" ttTranslate></tt-page-heading>
        </tt-card>

        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-3 p-5">
                <tt-input
                    *ngIf="!!setting"
                    ttLabel="searchtext"
                    [(ttModel)]="setting.searchtext"
                    (ttOnBlur)="onSearchTextBlur()"
                    [ttButtons]="searchTextButtons">
                </tt-input>
            </tt-card>

            <tt-card *ngIf="setting?.show === '1'" class="col-xs-12 col-md-3 p-5">
                <tt-button ttText="register_new_p2releasenote" ttTextAlign="left" ttIcon="fas fa-plus" (ttClick)="createReleaseNote($event)"></tt-button>
            </tt-card>
        </div>

        <tt-list
            *ngIf="itemState !== 'p2releasenoteedit'"
            [ttData]="itemsListReleaseNotes"
            [ttFilter]="setting?.searchtext">
        </tt-list>

        <ng-container *ngIf="itemState === 'p2releasenoteedit'">
            <tt-list
                *ngIf="selectedReleaseNoteKeyno === ''"
                [ttData]="itemsListReleaseNotes"
                [ttFilter]="setting?.searchtext"
                (ttClick)="openReleaseNote($event.item)">
            </tt-list>

            <div *ngIf="selectedReleaseNoteKeyno !== ''" class="col-xs-12 sp-0">
                <tt-list
                    [ttData]="itemsListReleaseNotes"
                    [ttFilter]="setting?.searchtext"
                    (ttClick)="openReleaseNote($event.item)">
                </tt-list>
                <tt-p2-release-note-edit
                    class="col-xs-12 col-md-6 p-5"
                    [inline]="true"
                    [p2ReleaseNoteKeyno]="selectedReleaseNoteKeyno"
                    (onSave)="updateReleaseNotes()">
                </tt-p2-release-note-edit>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #mobileView>
        <tt-card class="col-xs-12 sp-0">
            <tt-input
                *ngIf="!!setting"
                ttLabel="searchtext"
                [(ttModel)]="setting.searchtext"
                (ttOnBlur)="onSearchTextBlur()"
                [ttButtons]="searchTextButtons">
            </tt-input>
            <tt-button-goto
                *ngIf="setting?.show === '1'"
                ttText="register_new_p2releasenote"
                ttGoto="p2releasenoteedit-test"
                [ttGotoParms]="{ p2_releasenote_keyno: '0' }"
                ttTextAlign="left"
                ttIcon="fas fa-plus">
            </tt-button-goto>
        </tt-card>

        <tt-list
            [ttData]="itemsListReleaseNotes"
            [ttFilter]="setting?.searchtext">
        </tt-list>
    </ng-template>
</tt-page>
